import React from 'react';

import Icon from '../Icon/Icon';

const RenameBlueIcon = (props) => {
    return (
        <Icon width='48' height='48' fill='none' {...props}>
            <path
                d='M30.5 13.5001C32.7091 13.5001 34.5 15.291 34.5 17.5001V38.0001C34.5 40.2092 32.7091 42.0001 30.5 42.0001H10C7.79087 42.0001 6.00002 40.2092 6 38.0001V17.5001C6 15.291 7.79086 13.5001 10 13.5001H30.5Z'
                fill='#393E44'
            />
            <path
                d='M36.9668 5.44852C37.6076 4.80772 38.6222 4.76752 39.3096 5.3284L39.4424 5.44852L42.624 8.63016C43.3074 9.3135 43.3072 10.4213 42.624 11.1048L21.9414 31.7884L21.7744 31.9554L21.5508 32.0296L16.6094 33.677C15.2414 34.1329 13.9397 32.8311 14.3955 31.4632L16.043 26.5218L16.1172 26.2981L36.9668 5.44852Z'
                stroke='#FFFDFB'
                strokeWidth='2'
            />
            <path
                d='M37.6743 6.15512C37.9672 5.86223 38.4421 5.86223 38.735 6.15513L41.917 9.33711C42.2099 9.63 42.2099 10.1049 41.917 10.3978L21.2341 31.0806L16.9915 26.838L37.6743 6.15512Z'
                fill='#393E44'
            />
            <path
                d='M16.2932 32.7276C15.7068 32.9231 15.149 32.3653 15.3445 31.7789L16.9915 26.838L21.2341 31.0806L16.2932 32.7276Z'
                fill='#393E44'
            />
            <path d='M35.0234 8.8071L39.2661 13.0497L36.6144 15.7014L32.3718 11.4587L35.0234 8.8071Z' fill='#00D1D2' />
        </Icon>
    );
};

export default RenameBlueIcon;
